/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Religious_Studies21Inputs */

const en__field_enum_study_religious_studies21 = /** @type {(inputs: _Field_Enum_Study_Religious_Studies21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religious Studies`)
};

const de__field_enum_study_religious_studies21 = /** @type {(inputs: _Field_Enum_Study_Religious_Studies21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Religionswissenschaft`)
};

/**
* | output |
* | --- |
* | "Religious Studies" |
*
* @param {_Field_Enum_Study_Religious_Studies21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_religious_studies21 = /** @type {((inputs?: _Field_Enum_Study_Religious_Studies21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Religious_Studies21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_religious_studies21(inputs)
	return de__field_enum_study_religious_studies21(inputs)
});
export { _field_enum_study_religious_studies21 as "_field_enum_STUDY_RELIGIOUS_STUDIES" }